import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(legacy)/hashtags/$id')({
	loader: ({ params }) => {
		throw redirect({
			to: '/hashtag/$id',
			replace: true,
			params,
		})
	},
})
